import {Button, Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"
import {useParams, useLocation, useNavigate} from "react-router-dom"

import {Page} from "@indebted/components/Page"
import {useAnalytics} from "@indebted/analytics"
import {AcceptedCards} from "@indebted/components/AcceptedCards"

function PaymentMethodSelection({i18n, paymentMethods}) {
	const location = useLocation()
	const navigate = useNavigate()
	const {secureCode} = useParams()
	const {track} = useAnalytics()
	if (paymentMethods.length === 1) {
		navigate(`../${paymentMethods[0].ID}${location.search}`, {replace: true})
		return null
	}

	track("PPMethodPageViewed", {
		SecureCode: secureCode,
	})

	return (
		<Page padded>
			<Grid
				container
				direction="column"
				alignItems="stretch"
				justifyContent="center"
				style={{width: "100%"}}
				spacing={5}
			>
				<Grid>
					<Typography variant="h6">{i18n.Header}</Typography>
				</Grid>
				<Grid>
					<Typography>{i18n.Title}</Typography>
				</Grid>

				<ButtonsGrid container direction="column" alignItems="stretch" spacing={5}>
					{paymentMethods.map((method) => (
						<Grid key={method.ID}>
							<Button
								fullWidth
								variant="outlined"
								onClick={() => {
									track("PPMethodButtonClicked", {
										Method: method.ID,
										SecureCode: secureCode,
									})
									navigate(`../${method.ID}${location.search}`)
								}}
							>
								{method.Display}
							</Button>
							<AcceptedCards list={method.AcceptedCards} />
						</Grid>
					))}
				</ButtonsGrid>
			</Grid>
		</Page>
	)
}

const ButtonsGrid = styled(Grid)`
	margin-top: 20px;
`

export {PaymentMethodSelection}
